import { ReactElement } from 'react';
import ExerciseManagement from '../../../components/exercise/ExerciseManagement';

const SuperAdminExercises = (): ReactElement => {
  return (
    <ExerciseManagement mode="superAdmin" />
  )
}

export default SuperAdminExercises